export default __webpack_public_path__ + "static/media/IconSireGroups.6bbe4535.svg";